import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import {
    Modal,
    Box,
    Typography,
    FormControl,
    TextField,
    Button,
    Autocomplete,
    InputAdornment,
    Stack,
    Divider as MuiDivider,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { IoClose, IoFlagOutline } from "react-icons/io5";
import { GoPlus } from "react-icons/go";
import { RxUpload } from "react-icons/rx";
import { Divider } from "antd";
import { getProject } from "../../services/project.service";
import {
    getProjectBasedUser,
    postTask,
    updateTask,
    getTaskTitleByProject,
} from "../../services/taskManagement.service";
import { useNavigate } from "react-router-dom";
import ProjectSide_Icon from "../../assets/images/ProjectSide_Icon.svg";
import Bugs_Icon from "../../assets/images/bug.png";
import Task_Icon from "../../assets/images/Task_Icon.svg";
import Meeting_Icon from "../../assets/images/Meeting.png";
import Extra_Icon from "../../assets/images/Extra_Icon.svg";
import Testing_Icon from "../../assets/images/Testing_Icon.svg";
import Designing_Icon from "../../assets/images/Designing_Icon.svg";
import Deployment_Icon from "../../assets/images/Deployment_Icon.svg";
import { useAuth } from "../../context/AuthProvider";
import { jwtDecode } from "jwt-decode";
import { getTokenbyData } from "../../services/user.service";
import {
    DatePicker,
    TimePicker,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FileUploader } from "react-drag-drop-files";
import { getProjectParentTask } from "../../services/parentTask";
import { getParentTask } from "../../services/parentTask";
import { PRIORITY, ISSUETYPE } from "../../common/constant/constant";

const AddTaskModal = (props) => {
    const {
        setOpenDrawer,
        formType,
        selectedData,
        GetData,
        open,
        onClose,
        fetchTasks,
        selectedRightValue,
        filteredStatus,
        defaultIssueType, // Add defaultIssueType prop
        preFilledData, // Add preFilledData prop
        isRelatedBug, // Add isRelatedBug prop to disable certain fields
    } = props;

    const { accessToken } = useAuth();
    const navigate = useNavigate();
    const formRef = useRef(null);
    const disabled = formType === "view";
    const [projectData, setProjectData] = useState([]);
    const [projectParentData, setProjectParentData] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [taskOption, setTaskOption] = useState([]);
    const [testingTaskOptions, setTestingTaskOptions] = useState([]);
    const [ParentTaskData, setParentTaskData] = useState([]);
    const [fileName, setFileName] = useState(
        formType === "edit" ? selectedData?.file?.fileName : 0
    );
    const [shouldCloseOnSave, setShouldCloseOnSave] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [initialValues, setInitialValues] = useState({
        issueType: defaultIssueType || null,
        title: preFilledData?.title || "",
        description: preFilledData?.description || "",
        project: preFilledData?.project?._id || preFilledData?.project || "",
        parentTask: preFilledData?.parentTask?._id || preFilledData?.parentTask || null,
        assignedBy: "",
        assignee: preFilledData?.assignee?._id || preFilledData?.assignee || "",
        priority: preFilledData?.priority || PRIORITY.MEDIUM,
        actualDeadlineDate: preFilledData?.actualDeadlineDate || "",
        estimatedTime: preFilledData?.estimatedTime || "",
        file: [],
        isclientView: false,
        relatedTask: preFilledData?.relatedTask || null,
        testingTasks: preFilledData?.testingTasks || [],
        workLog: [{ startTime: null, endTime: null }],
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [meeting, setMeeting] = useState(selectedData?.taskType);

    const priorityOption = [
        {
            label: "Low",
            name: PRIORITY.LOW,
            icon: <IoFlagOutline size={16} color={"#21A600"} />,
        },
        {
            label: "Medium",
            name: PRIORITY.MEDIUM,
            icon: <IoFlagOutline size={16} color={"#D7BB21"} />,
        },
        {
            label: "High",
            name: PRIORITY.HIGH,
            icon: <IoFlagOutline size={16} color={"#D50707"} />,
        },
    ];

    const validationSchema = Yup.object().shape({
        issueType: Yup.number()
            .typeError("Issue Type must be a number")
            .required("Issue Type is required"),

        title: Yup.string()
            .trim()
            .required("Title is required")
            .min(1, "Title cannot be empty"),

        // description: Yup.string()
        //   .required("Description is required")
        //   .test(
        //     "is-not-empty",
        //     "Description is required",
        //     (value) => !value || value.replace(/<(.|\n)*?>/g, "").trim().length > 0
        //   ),

        project: Yup.string().required("Project is required"),

        // Parent Task - Not required for MEETING, TESTING, DEPLOYMENT, OTHERS
        parentTask: Yup.string().when("issueType", {
            is: (val) => ![ISSUETYPE.MEETING, ISSUETYPE.TESTING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(val),
            then: (schema) => schema.required("Parent Task is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // Priority - Not required (will be set to default Medium for specific types)
        priority: Yup.number()
            .typeError("Priority must be a number")
            .notRequired(),

        assignee: Yup.string().required("Assignee is required"),

        // Deadline Date - Only required for BUG and TASK
        // actualDeadlineDate: Yup.date().nullable().when("issueType", {
        //     is: (val) => [ISSUETYPE.BUG, ISSUETYPE.TASK].includes(val),
        //     then: (schema) => schema.typeError("Invalid date format").required("Deadline Date is required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),

        // Estimated Time - Required for TESTING, DESIGNING, DEPLOYMENT, OTHERS
        // estimatedTime: Yup.number().nullable().when("issueType", {
        //     is: (val) => [ISSUETYPE.TESTING, ISSUETYPE.DESIGNING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(val),
        //     then: (schema) => schema
        //         .typeError("Estimated Time must be a number")
        //         .positive("Estimated Time must be positive")
        //         .required("Estimated Time is required"),
        //     otherwise: (schema) => schema.notRequired(),
        // }),

        // Testing Tasks - Not mandatory
        testingTasks: Yup.array().notRequired(),

        workLog: Yup.array().of(
            Yup.object().shape({
                startTime: Yup.date().nullable(),
                endTime: Yup.date().nullable(),
            })
        ),
    });

    const checkOverlap = (newStart, newEnd, currentIndex, allLogs) => {
        if (!newStart || !newEnd) return false;

        const start = dayjs(newStart);
        const end = dayjs(newEnd);

        return allLogs.some((log, index) => {
            if (index === currentIndex) return false; // Skip the log being edited
            if (!log.startTime || !log.endTime) return false;

            const logStart = dayjs(log.startTime);
            const logEnd = dayjs(log.endTime);

            // Check overlap logic: (StartA < EndB) and (EndA > StartB)
            return start.isBefore(logEnd) && end.isAfter(logStart);
        });
    };

    const getUserIdFromToken = () => {
        if (!accessToken) return null;
        try {
            const decoded = jwtDecode(accessToken);
            return decoded.id;
        } catch (error) {
            console.error("Invalid token", error);
            return null;
        }
    };

    const GetProjectData = async () => {
        try {
            const res = await getProject({ isEnabled: true });
            const userId = getUserIdFromToken();
            console.log("userId", userId);
            // Get current user data to check if they are admin
            const userRes = await getTokenbyData();
            const userData = userRes?.data;
            const isAdminUser = userData?.isOverAllAdmin || false;
            setIsAdmin(isAdminUser);
            const isManager = userData?.isManager || false;

            // Auto-set assignee for non-admin users
            if (!isAdminUser && userId) {
                setInitialValues((prev) => ({
                    ...prev,
                    assignee: userId
                }));
            }

            let filteredProjects = res.data.data;

            // If user is not admin and not manager, filter projects
            // if (!isAdmin && !isManager && userId) {
            //   const allProjects = res.data.data;

            //   // Helper to check if user is lead on a specific project
            //   const checkIsLead = (project) => {
            //     return project.projectLead?.some((lead) => {
            //       const leadId = lead?._id || lead;
            //       return leadId?.toString() === userId?.toString();
            //     });
            //   };

            //   // Determine if user is a lead on ANY project
            //   const isProjectLeadRole = allProjects.some(checkIsLead);

            //   filteredProjects = allProjects.filter((project) => {
            //     const isLead = checkIsLead(project);

            //     // Check if user is assigned to the project
            //     const isAssigned = userData.project?.some((pId) => {
            //       const id = pId?._id || pId;
            //       return id?.toString() === project?._id?.toString();
            //     });

            //     if (isProjectLeadRole) {
            //       // If user is a lead somewhere, show ONLY projects they lead
            //       return isLead;
            //     } else {
            //       // If user is not a lead anywhere, show assigned projects
            //       return isAssigned;
            //     }
            //   });
            // }

            const configData = filteredProjects.map((e) => {
                return {
                    ...e,
                    label: e.name,
                };
            });
            setProjectData(configData);
        } catch (error) {
            console.log(error);
        }
    };
    const GetProjectParentData = async (projectId) => {
        try {
            const res = await getProjectParentTask(projectId, { isEnabled: true });
            const configData = res.data.data.map((e) => {
                return {
                    ...e,
                    label: e.name,
                };
            });
            setProjectParentData(configData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetProjectData();
    }, []);

    const GetProjectBasedUserData = async (selectedProjectId) => {
        try {
            console.log("selectedProjectId", selectedProjectId);
            if (selectedProjectId != undefined) {
                const res = await getProjectBasedUser(selectedProjectId);
                const Parenttask = await getProjectParentTask(selectedProjectId);
                const configData = res?.data?.data?.map((e) => {
                    return {
                        ...e,
                        label: e.fullName,
                    };
                });
                setParentTaskData(Parenttask?.data?.data);
                setEmployeeData(configData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const GetTestingTasks = async (projectId) => {
        try {
            if (projectId) {
                const res = await getTaskTitleByProject(projectId);
                if (res.error === false) {
                    setTestingTaskOptions(res.data.data);
                }
            }
        } catch (error) {
            console.error("Error fetching testing tasks:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getTokenbyData();
                const usersData = res.data;
                const isClient = usersData?.isClient || false;
                console.log("isClientssss", isClient);

                const allTaskOptions = [
                    {
                        label: "Bugs",
                        name: ISSUETYPE.BUG,
                        icon: (
                            <img
                                src={Bugs_Icon}
                                alt="Bugs_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Task",
                        name: ISSUETYPE.TASK,
                        icon: (
                            <img
                                src={Task_Icon}
                                alt="Task_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Meeting",
                        name: ISSUETYPE.MEETING,
                        icon: (
                            <img
                                src={Meeting_Icon}
                                alt="Meeting_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Testing",
                        name: ISSUETYPE.TESTING,
                        icon: (
                            <img
                                src={Testing_Icon}
                                alt="Testing_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Designing",
                        name: ISSUETYPE.DESIGNING,
                        icon: (
                            <img
                                src={Designing_Icon}
                                alt="Designing_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Others",
                        name: ISSUETYPE.OTHERS,
                        icon: (
                            <img
                                src={Extra_Icon}
                                alt="Extra_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                    {
                        label: "Deployment",
                        name: ISSUETYPE.DEPLOYMENT,
                        icon: (
                            <img
                                src={Deployment_Icon}
                                alt="Deployment_Icon"
                                style={{
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                        ),
                    },
                ];

                // Filter task options based on defaultIssueType
                let filteredTaskOptions;
                if (defaultIssueType === ISSUETYPE.BUG) {
                    // If opened from Bug Management page, show only Bug option
                    filteredTaskOptions = allTaskOptions.filter(
                        (option) => option.name === ISSUETYPE.BUG || option.name === ISSUETYPE.TASK
                    );
                } else {
                    // If opened from Task Management page, exclude Bugs option
                    filteredTaskOptions = allTaskOptions.filter(
                        (option) => option.name !== ISSUETYPE.BUG && option.name !== ISSUETYPE.TASK
                    );
                }

                if (isClient) {
                    setTaskOption(filteredTaskOptions);
                } else {
                    setTaskOption(filteredTaskOptions);
                }
            } catch (error) {
                console.error("Error fetching role data:", error);
            }
        };

        fetchData();
    }, [defaultIssueType]);

    useEffect(() => {
        GetProjectData();
        if (formType === "edit" || formType === "view") {
            const files = selectedData?.file?.map((file) => file?.fileName) || [];
            setInitialValues({
                issueType: selectedData.issueType || null,
                title: selectedData.title || "",
                description: selectedData.description || "",
                parentTask: selectedData.parentTask || "",
                project: selectedData.project || "",
                priority:
                    priorityOption.find(
                        (o) =>
                            o.label === selectedData.priority ||
                            o.name === selectedData.priority
                    )?.name ?? PRIORITY.MEDIUM,
                assignee: selectedData?.assignee || "",
                actualDeadlineDate: selectedData?.actualDeadlineDate || "",
                estimatedTime: selectedData?.estimatedTime || "",
                isclientView: selectedData?.isclientView || false,
                testingTasks: selectedData?.testingTasks || [],
            });
            setFileName(files.join(", "));
            if (selectedData.project) {
                GetTestingTasks(selectedData.project);
            }
        } else if (preFilledData && Object.keys(preFilledData).length > 0) {
            console.log("Setting initial values from preFilledData:", preFilledData);
            // Set initial values when preFilledData is provided (e.g., from Add Bug button)
            setInitialValues((prev) => {
                const newValues = {
                    ...prev,
                    issueType: defaultIssueType,
                    title: preFilledData.title !== undefined ? preFilledData.title : prev.title,
                    description: preFilledData.description !== undefined ? preFilledData.description : prev.description,
                    project: (preFilledData.project?._id || preFilledData.project) || prev.project,
                    parentTask: (preFilledData.parentTask?._id || preFilledData.parentTask) || prev.parentTask,
                    assignee: (preFilledData.assignee?._id || preFilledData.assignee) || prev.assignee,
                    priority: preFilledData.priority !== undefined ? preFilledData.priority : prev.priority,
                    actualDeadlineDate: preFilledData.actualDeadlineDate !== undefined ? preFilledData.actualDeadlineDate : prev.actualDeadlineDate,
                    estimatedTime: preFilledData.estimatedTime !== undefined ? preFilledData.estimatedTime : prev.estimatedTime,
                    relatedTask: preFilledData.relatedTask || prev.relatedTask,
                };
                console.log("New Initial Values Calculated:", newValues);
                return newValues;
            });
        }

        // Load project-based data if preFilledData has a project
        if (preFilledData?.project) {
            const projectId = preFilledData.project?._id || preFilledData.project;
            console.log("Fetching project data for project ID:", projectId);
            GetProjectBasedUserData(projectId);
            GetTestingTasks(projectId);
        }
    }, [formType, selectedData, preFilledData, defaultIssueType]);

    // Auto-set priority to Medium for specific issue types
    useEffect(() => {
        const shouldSetMediumPriority = [
            ISSUETYPE.MEETING,
            ISSUETYPE.TESTING,
            ISSUETYPE.DESIGNING,
            ISSUETYPE.DEPLOYMENT,
            ISSUETYPE.OTHERS
        ].includes(initialValues.issueType);

        if (shouldSetMediumPriority && initialValues.priority !== PRIORITY.MEDIUM) {
            setInitialValues(prev => ({
                ...prev,
                priority: PRIORITY.MEDIUM
            }));
        }
    }, [initialValues.issueType]);

    const handleCancel = () => {
        navigate("/home/taskManagement", {
            state: {
                selectedRightValue: selectedRightValue,
                filteredStatus: filteredStatus,
            },
        });
    };

    const onSubmit = async (values, { resetForm }) => {
        setIsSaving(true);
        try {
            const formData = new FormData();
            const { files, ...bodyData } = values;
            const assignedBy = getUserIdFromToken();

            // Append files if they exist
            if (files && files.length) {
                files.forEach((file) => {
                    formData.append("files", file);
                });
            }

            // Prepare workLogs with additional fields
            if (bodyData.workLog && Array.isArray(bodyData.workLog)) {
                bodyData.workLog = bodyData.workLog.map((log) => ({
                    ...log,
                    date: dayjs().toISOString(),
                    assignedTo: typeof bodyData.assignee === 'object' ? bodyData.assignee._id : bodyData.assignee,
                    assignedBy: assignedBy,
                }));
            }

            // Validate Start/End Time Logic
            const invalidTime = bodyData.workLog.some((log) => {
                if (!log.startTime || !log.endTime) return false; // Skip empty logs here, caught by hasValidWorkLog
                return dayjs(log.startTime).isAfter(dayjs(log.endTime)) || dayjs(log.startTime).isSame(dayjs(log.endTime));
            });

            if (invalidTime) {
                ToastError("End Time must be greater than Start Time.");
                setIsSaving(false);
                return;
            }

            // check if any worklog is empty
            const hasEmptyWorkLog = bodyData.workLog.some(log => !log.startTime || !log.endTime);
            if (hasEmptyWorkLog) {
                ToastError("Please fill all worklog entries or remove empty ones.");
                setIsSaving(false);
                return;
            }

            // Validate that at least one work log is present and valid
            const hasValidWorkLog = bodyData.workLog.some(log => log.startTime && log.endTime);
            if (!hasValidWorkLog) {
                ToastError("One worklog was wanted");
                setIsSaving(false);
                return;
            }

            // Validate overlap in Frontend before submission (Sanity Check)
            const hasOverlap = bodyData.workLog.some((log, index) =>
                checkOverlap(log.startTime, log.endTime, index, bodyData.workLog)
            );

            if (hasOverlap) {
                ToastError("Time slots overlap. Please correct them.");
                setIsSaving(false);
                return;
            }

            // Clear testingTasks if not TESTING type
            if (bodyData.issueType !== ISSUETYPE.TESTING) {
                bodyData.testingTasks = [];
            }

            // Clear parentTask for MEETING, TESTING, DEPLOYMENT, OTHERS
            if ([ISSUETYPE.MEETING, ISSUETYPE.TESTING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(bodyData.issueType)) {
                bodyData.parentTask = null;
            }

            const assigneeId = typeof bodyData.assignee === 'object' ? bodyData.assignee._id : bodyData.assignee;
            const filteredBodyData = { ...bodyData, assignee: assigneeId, assignedBy, status: 0 };

            // Existing Logic: Single creation or Edit
            // Append the body data
            formData.append("bodyData", JSON.stringify(filteredBodyData));

            // Determine whether to create or update
            const apiMethod =
                formType === "edit"
                    ? updateTask(selectedData._id, formData)
                    : postTask(formData);

            // Execute the API call
            const res = await apiMethod;
            if (res.error === false) {
                ToastSuccess(res.data.message);
                fetchTasks();
                if (shouldCloseOnSave) {
                    onClose();
                } else {
                    // Reset form fields if Save (not Save and Exit)
                    resetForm();
                }
            }
        } catch (error) {
            console.error("Submit Error:", error);
            let errorMessage = error?.data?.message || "An error occurred";

            // Simplify verbose time conflict message
            if (errorMessage.includes("Time conflict") || errorMessage.includes("User already has work") || errorMessage.includes("overlaps with existing schedule")) {
                const taskMatch = errorMessage.match(/task\s+([A-Z0-9-]+)/i);
                const taskId = taskMatch ? taskMatch[1] : null;

                const scheduleMatch = errorMessage.match(/scheduled on\s+(.*?)\s+from\s+(.*?)\s+to\s+(.*?)(?:\.|$)/i);
                const simpleTimeMatch = errorMessage.match(/\(([^)]+)\)/);

                if (taskId && scheduleMatch) {
                    errorMessage = `Time overlap with ${taskId} on ${scheduleMatch[1]} (${scheduleMatch[2]} - ${scheduleMatch[3]})`;
                } else if (taskId && simpleTimeMatch) {
                    errorMessage = `Time overlap with ${taskId} (${simpleTimeMatch[1]})`;
                } else if (scheduleMatch) {
                    errorMessage = `Time overlap! Existing work on ${scheduleMatch[1]} (${scheduleMatch[2]} - ${scheduleMatch[3]})`;
                } else if (taskId) {
                    errorMessage = `Time overlap with ${taskId}`;
                } else {
                    errorMessage = "Time overlap with an existing task. Please check the timings.";
                }
            }

            ToastError(errorMessage);
        } finally {
            setIsSaving(false);
        }
    };
    const truncateTitle = (title, maxWords = 4) => {
        if (!title) return "";
        const words = title.split(" ");
        if (words.length <= maxWords) return title;
        return words.slice(0, maxWords).join(" ") + "...";
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "95%", sm: "80%", md: "52%" },
                    height: { xs: "95%", sm: "90%" },
                    bgcolor: "background.paper",
                    maxHeight: "90vh",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    overflowY: "auto",
                }}
            >
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    innerRef={formRef}
                >
                    {({ touched, errors, values, setFieldValue }) => (
                        <Form>
                            <Stack
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                            >
                                <Typography variant="h6">
                                    {formType === "edit"
                                        ? "Edit"
                                        : formType === "view"
                                            ? "View"
                                            : "Add"}{" "}
                                    Task
                                </Typography>
                                <Box sx={{ cursor: "pointer" }} onClick={onClose}>
                                    <IoClose size={24} />
                                </Box>
                            </Stack>
                            <MuiDivider sx={{ opacity: 1, my: 0.5 }} />
                            {/* // <Divider style={{ color: "black", mt: 0.5 }} /> */}
                            <Stack spacing={2} mt={2}>
                                {/* Issue Type & Priority - Moved to Top */}
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                    <FormControl fullWidth>
                                        <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                            Issue Type *
                                        </Typography>
                                        <Autocomplete
                                            options={taskOption}
                                            value={
                                                taskOption.find(
                                                    (option) =>
                                                        option.name === values.issueType ||
                                                        option.label === values.issueType
                                                ) || null
                                            }
                                            onChange={(e, v) => {
                                                setFieldValue("issueType", v?.name);
                                                if (v?.name === ISSUETYPE.TESTING && values.project) {
                                                    GetTestingTasks(values.project);
                                                }
                                            }}
                                            disabled={isRelatedBug || disabled}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    <span
                                                        style={{
                                                            marginRight: "8px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {option.icon}
                                                    </span>
                                                    {option.label}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Issue Type"
                                                    error={touched.issueType && Boolean(errors.issueType)}
                                                    helperText={touched.issueType && errors.issueType}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        startAdornment:
                                                            values.issueType !== null ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        marginRight: "8px",
                                                                    }}
                                                                >
                                                                    {
                                                                        taskOption.find(
                                                                            (option) =>
                                                                                option.name === values.issueType ||
                                                                                option.label === values.issueType
                                                                        )?.icon
                                                                    }
                                                                </div>
                                                            ) : null,
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    {/* Hide Priority for MEETING, TESTING, DESIGNING, DEPLOYMENT, OTHERS */}
                                    {![ISSUETYPE.MEETING, ISSUETYPE.TESTING, ISSUETYPE.DESIGNING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(values.issueType) && (
                                        <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Priority *
                                            </Typography>
                                            <Autocomplete
                                                options={priorityOption}
                                                value={
                                                    priorityOption.find(
                                                        (option) => option.name === values.priority
                                                    ) || null
                                                }
                                                onChange={(e, v) => {
                                                    setFieldValue("priority", v?.name);
                                                }}
                                                disabled={isRelatedBug || disabled}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <span
                                                            style={{
                                                                marginRight: "8px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            {option.icon}
                                                        </span>
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Priority"
                                                        error={touched.priority && Boolean(errors.priority)}
                                                        helperText={touched.priority && errors.priority}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            startAdornment: values.priority ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        marginRight: "8px",
                                                                    }}
                                                                >
                                                                    {
                                                                        priorityOption.find(
                                                                            (option) => option.name === values.priority
                                                                        )?.icon
                                                                    }
                                                                </div>
                                                            ) : null,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    )}
                                    {/* Project */}
                                    <FormControl fullWidth>
                                        <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                            Project *
                                        </Typography>
                                        <Autocomplete
                                            options={projectData}
                                            value={
                                                projectData.find(
                                                    (option) => option._id === values.project
                                                ) || null
                                            }
                                            onChange={(e, v) => {
                                                setFieldValue("project", v?._id);
                                                GetProjectBasedUserData(v?._id);
                                                GetTestingTasks(v?._id);
                                            }}
                                            disabled={isRelatedBug || disabled}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Project"
                                                    error={touched.project && Boolean(errors.project)}
                                                    helperText={touched.project && errors.project}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Stack>

                                {/* Row 2: Parent Task / Testing Tasks / Assignee */}
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>

                                    {/* Hide Parent Task for MEETING, TESTING, DEPLOYMENT, OTHERS */}
                                    {![ISSUETYPE.MEETING, ISSUETYPE.TESTING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(values.issueType) && (
                                        <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Parent Task *
                                            </Typography>
                                            <Autocomplete
                                                options={ParentTaskData}
                                                value={
                                                    ParentTaskData.find(
                                                        (option) => option._id === values.parentTask
                                                    ) || null
                                                }
                                                getOptionLabel={(option) => {
                                                    const projectTypeName = option.projectType?.name
                                                        ? ` (${option.projectType.name})`
                                                        : "";
                                                    return option?.title
                                                        ? `${option.code} - ${truncateTitle(
                                                            option.title
                                                        )}${projectTypeName}`
                                                        : option.code || "";
                                                }}
                                                onChange={(e, v) => {
                                                    setFieldValue("parentTask", v?._id);
                                                }}
                                                disabled={isRelatedBug || disabled}
                                                renderOption={(props, option) => {
                                                    const projectTypeName = option.projectType?.name
                                                        ? ` (${option.projectType.name})`
                                                        : "";
                                                    return (
                                                        <li {...props}>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    width: "100%",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        marginRight: "8px",
                                                                        flex: 1,
                                                                    }}
                                                                >
                                                                    {option.code} - {option.title}
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        whiteSpace: "nowrap",
                                                                        fontSize: "0.85em",
                                                                        color: "text.secondary",
                                                                        fontWeight: "500",
                                                                    }}
                                                                >
                                                                    {projectTypeName}
                                                                </span>
                                                            </div>
                                                        </li>
                                                    );
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Parent Task"
                                                        error={
                                                            touched.parentTask && Boolean(errors.parentTask)
                                                        }
                                                        helperText={touched.parentTask && errors.parentTask}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    )}
                                    {values.issueType === ISSUETYPE.TESTING && (
                                        <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Testing Tasks
                                            </Typography>
                                            <Autocomplete
                                                multiple
                                                options={testingTaskOptions}
                                                value={
                                                    testingTaskOptions.filter((option) =>
                                                        values.testingTasks?.includes(option._id)
                                                    ) || []
                                                }
                                                getOptionLabel={(option) => `${option.taskNo} - ${option.title}`}
                                                onChange={(e, v) => {
                                                    setFieldValue(
                                                        "testingTasks",
                                                        v.map((opt) => opt._id)
                                                    );
                                                }}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <Box>
                                                            <Typography variant="body2" fontWeight="600">
                                                                {option.taskNo} - {option.title}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    fontSize: "0.75rem",
                                                                    color: "text.secondary",
                                                                    maxHeight: "3em",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: option.description,
                                                                }}
                                                            />
                                                        </Box>
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Testing Tasks"
                                                        error={
                                                            touched.testingTasks &&
                                                            Boolean(errors.testingTasks)
                                                        }
                                                        helperText={
                                                            touched.testingTasks && errors.testingTasks
                                                        }
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    )}

                                    {/* Assignee */}
                                    {/* Assignee - Only visible for Admin */}
                                    {isAdmin && (
                                        <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Assignee *
                                            </Typography>
                                            <Autocomplete
                                                options={employeeData}
                                                value={
                                                    employeeData.find(
                                                        (option) => option._id === values.assignee
                                                    ) || null
                                                }
                                                onChange={(e, v) => {
                                                    setFieldValue("assignee", v?._id);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Assignee"
                                                        error={
                                                            touched.assignee && Boolean(errors.assignee)
                                                        }
                                                        helperText={touched.assignee && errors.assignee}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    )}
                                </Stack>

                                {/* Row 3: Title */}
                                <FormControl fullWidth>
                                    <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                        Title *
                                    </Typography>
                                    <Field
                                        name="title"
                                        as={TextField}
                                        fullWidth
                                        placeholder="Enter Title"
                                        disabled={disabled}
                                        error={touched.title && Boolean(errors.title)}
                                        helperText={touched.title && errors.title}
                                    />
                                </FormControl>

                                {/* Row 4: Deadline, Estimate - Hidden for Meeting */}
                                {/* {values.issueType !== ISSUETYPE.MEETING && (
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        {/* Deadline Date - Required only for BUG and TASK */}
                                {/* <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Deadline Date {[ISSUETYPE.BUG, ISSUETYPE.TASK].includes(values.issueType) && "*"}
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={values.actualDeadlineDate ? dayjs(values.actualDeadlineDate) : null}
                                                    onChange={(newValue) => {
                                                        setFieldValue("actualDeadlineDate", newValue);
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            fullWidth: true,
                                                            placeholder: "Select Deadline Date",
                                                            error: touched.actualDeadlineDate && Boolean(errors.actualDeadlineDate),
                                                            helperText: touched.actualDeadlineDate && errors.actualDeadlineDate,
                                                        },
                                                    }}
                                                    format="DD/MM/YYYY"
                                                    disabled={disabled}
                                                />
                                            </LocalizationProvider>
                                        </FormControl> */}

                                {/* Estimate Time - Required for TESTING, DESIGNING, DEPLOYMENT, OTHERS */}
                                {/* <FormControl fullWidth>
                                            <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                                Estimate Time (Hours) {[ISSUETYPE.TESTING, ISSUETYPE.DESIGNING, ISSUETYPE.DEPLOYMENT, ISSUETYPE.OTHERS].includes(values.issueType) && "*"}
                                            </Typography>
                                            <Field
                                                name="estimatedTime"
                                                as={TextField}
                                                type="number"
                                                fullWidth
                                                size="small"
                                                placeholder="Enter Hours"
                                                disabled={disabled}
                                                error={touched.estimatedTime && Boolean(errors.estimatedTime)}
                                                helperText={touched.estimatedTime && errors.estimatedTime}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 0.5 }
                                                }}
                                            />
                                        </FormControl> */}
                                {/* </Stack>
                                )} */}

                                <FormControl fullWidth>
                                    <Typography variant="subtitle2" sx={{ mb: 0.8, fontWeight: 600 }}>
                                        Description
                                    </Typography>
                                    <Field
                                        name="description"
                                        render={({ field, form }) => (
                                            <ReactQuill
                                                value={field.value || ""}
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                }}
                                                placeholder="Enter Description"
                                                style={{
                                                    borderRadius: "8px",
                                                    height: "130px",
                                                    marginBottom: "40px",
                                                }}
                                                disabled={disabled}
                                                modules={{
                                                    toolbar: [
                                                        [
                                                            { header: "1" },
                                                            { header: "2" },
                                                            { font: [] },
                                                        ],
                                                        [{ list: "ordered" }, { list: "bullet" }],
                                                        ["bold", "italic", "underline"],
                                                        [{ align: [] }],
                                                    ],
                                                }}
                                            />
                                        )}
                                    />
                                    {touched.description && errors.description && (
                                        <Typography color="error" variant="caption">
                                            {errors.description}
                                        </Typography>
                                    )}
                                </FormControl>

                                {/* Dynamic WORKLOGS Input */}
                                <Stack spacing={2}>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Typography variant="body1" fontWeight="600">Work Logs</Typography>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => {
                                                const newWorkLog = [
                                                    ...(values.workLog || []),
                                                    { startTime: null, endTime: null },
                                                ];
                                                setFieldValue("workLog", newWorkLog);
                                            }}
                                            startIcon={
                                                <GoPlus size={16} />
                                            }
                                            sx={{
                                                borderColor: "#008080",
                                                color: "#008080",
                                                "&:hover": {
                                                    backgroundColor: "#E7F5F6",
                                                    borderColor: "#008080",
                                                },
                                            }}
                                        >
                                            Add Time
                                        </Button>
                                    </Stack>

                                    {values.workLog &&
                                        values.workLog.map((log, index) => (
                                            <Stack
                                                key={index}
                                                direction={{ xs: "column", sm: "row" }}
                                                spacing={2}
                                                alignItems="center"
                                            >
                                                <FormControl fullWidth>
                                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                        Start Time
                                                    </Typography>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <TimePicker
                                                            value={log.startTime ? dayjs(log.startTime) : null}
                                                            onChange={(newValue) => {
                                                                setFieldValue(
                                                                    `workLog[${index}].startTime`,
                                                                    newValue
                                                                );
                                                            }}
                                                            slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            format="HH:mm"
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                                <FormControl fullWidth>
                                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                        End Time
                                                    </Typography>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <TimePicker
                                                            value={log.endTime ? dayjs(log.endTime) : null}
                                                            onChange={(newValue) => {
                                                                setFieldValue(
                                                                    `workLog[${index}].endTime`,
                                                                    newValue
                                                                );
                                                            }}
                                                            slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            format="HH:mm"
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                                {values.workLog.length > 1 && (
                                                    <Box sx={{ mt: 3, cursor: "pointer" }}>
                                                        <IoClose
                                                            size={20}
                                                            color="red"
                                                            onClick={() => {
                                                                const newWorkLog = values.workLog.filter(
                                                                    (_, i) => i !== index
                                                                );
                                                                setFieldValue("workLog", newWorkLog);
                                                            }}
                                                        />
                                                    </Box>
                                                )}
                                            </Stack>
                                        ))}
                                    {touched.workLog &&
                                        typeof errors.workLog === "string" && (
                                            <Typography color="error" variant="caption">
                                                {errors.workLog}
                                            </Typography>
                                        )}
                                </Stack>



                                {/* <FormControl fullWidth>
                                    <Stack direction={"row"} justifyContent={"space-between"}>
                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                            Upload Image or Video
                                        </Typography>
                                        {fileName?.length > 0 && (
                                            <IoClose
                                                onClick={() => {
                                                    setFileName("");
                                                    setFieldValue("files", []);
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                }}
                                            />
                                        )}
                                    </Stack>
                                    <FileUploader
                                        handleChange={(e) => {
                                            const files =
                                                e instanceof FileList ? Array.from(e) : [e];
                                            setFieldValue("files", files);
                                            setFileName(
                                                files.map((file) => file.name).join(", ")
                                            );
                                        }}
                                        name="files"
                                        multiple={true}
                                        dropMessageStyle={{
                                            color: "green",
                                            border: "none",
                                            borderRadius: "0px",
                                        }}
                                    >
                                        <Stack
                                            sx={{
                                                border: "2px dashed #B9BDC4",
                                                padding: 2,
                                                borderRadius: "6px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <Stack
                                                justifyContent={"center"}
                                                alignItems={"center"}
                                            >
                                                <RxUpload color="#008080" size={20} />
                                            </Stack>
                                            <Typography
                                                variant="body1"
                                                sx={{ fontSize: "12px", fontWeight: "500" }}
                                            >
                                                {fileName ? (
                                                    fileName
                                                ) : (
                                                    <>
                                                        Drag & Drop or{" "}
                                                        <span style={{ color: "#008080" }}>
                                                            Choose file
                                                        </span>{" "}
                                                        to upload
                                                    </>
                                                )}
                                            </Typography>
                                        </Stack>
                                    </FileUploader>
                                </FormControl> */}

                                <MuiDivider />

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column-reverse", sm: "row" },
                                        justifyContent: "space-between",
                                        gap: 2,
                                        mt: 3,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            width: { xs: "100%", sm: "auto" },
                                        }}
                                    >
                                        {/* <FormControlLabel
                                            label="Client View"
                                            control={
                                                <Field
                                                    type="checkbox"
                                                    name="isclientView"
                                                    as={Checkbox}
                                                    disabled={disabled}
                                                    sx={{
                                                        color: "#008080",
                                                        "&.Mui-checked": {
                                                            color: "#008080",
                                                        },
                                                    }}
                                                />
                                            }
                                        /> */}
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            gap: 2,
                                            width: { xs: "100%", sm: "auto" },
                                        }}
                                    >
                                        <Button
                                            onClick={onClose}
                                            variant="outlined"
                                            sx={{
                                                borderColor: "#008080",
                                                color: "#008080",
                                                fontSize: "14px",
                                                width: { xs: "100%", sm: "auto" },
                                                "&:hover": {
                                                    backgroundColor: "white",
                                                    color: "#008080",
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>

                                        <Button
                                            onClick={() => {
                                                setShouldCloseOnSave(false);
                                                formRef.current.handleSubmit();
                                            }}
                                            variant="contained"
                                            disabled={isSaving || disabled}
                                            sx={{
                                                backgroundColor: "#008080",
                                                color: "white",
                                                fontSize: "14px",
                                                width: { xs: "100%", sm: "auto" },
                                                "&:hover": {
                                                    backgroundColor: "#006666",
                                                },
                                                display: disabled ? "none" : "flex",
                                            }}
                                        >
                                            {isSaving && !shouldCloseOnSave ? "Saving..." : "Save"}
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                setShouldCloseOnSave(true);
                                                formRef.current.handleSubmit();
                                            }}
                                            variant="contained"
                                            disabled={isSaving || disabled}
                                            sx={{
                                                backgroundColor: "#008080",
                                                color: "white",
                                                fontSize: "14px",
                                                width: { xs: "100%", sm: "auto" },
                                                "&:hover": {
                                                    backgroundColor: "#006666",
                                                },
                                                display: disabled ? "none" : "flex",
                                            }}
                                        >
                                            {isSaving && shouldCloseOnSave
                                                ? "Saving..."
                                                : "Save and Exit"}
                                        </Button>
                                    </Box>
                                </Box>
                            </Stack>
                        </Form>
                    )}
                </Formik>
            </Box>
        </Modal>
    );
};

// Helper function to truncate title
const truncateTitle = (title, length = 20) => {
    if (!title) return "";
    return title.length > length ? title.substring(0, length) + "..." : title;
};

export default AddTaskModal;
